namespace TabAurous.OMS {
    export interface PromotionMasterForm {
        PromoName: Serenity.StringEditor;
        PromoType: Serenity.LookupEditor;
        PromoCode: Serenity.StringEditor;
        ApplicableOn: Serenity.LookupEditor;
        DiscountOn: Common.DiscountOnEditor;
        DiscountAmount: Serenity.DecimalEditor;
        DiscountPercentage: Serenity.DecimalEditor;
        MinimumSalesAmount: Serenity.DecimalEditor;
        CodeRequired: Serenity.BooleanEditor;
        MaximumRedeemCount: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        VoucherCode: Serenity.StringEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsApproved: Serenity.BooleanEditor;
        ApprovedBy: Serenity.LookupEditor;
        PromotionDetails: PromotionDetailsEditor;
    }

    export class PromotionMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PromotionMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PromotionMasterForm.init)  {
                PromotionMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = Common.DiscountOnEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DateEditor;
                var w6 = PromotionDetailsEditor;

                Q.initFormType(PromotionMasterForm, [
                    'PromoName', w0,
                    'PromoType', w1,
                    'PromoCode', w0,
                    'ApplicableOn', w1,
                    'DiscountOn', w2,
                    'DiscountAmount', w3,
                    'DiscountPercentage', w3,
                    'MinimumSalesAmount', w3,
                    'CodeRequired', w4,
                    'MaximumRedeemCount', w3,
                    'FromDate', w5,
                    'ToDate', w5,
                    'VoucherCode', w0,
                    'IsDisabled', w4,
                    'IsApproved', w4,
                    'ApprovedBy', w1,
                    'PromotionDetails', w6
                ]);
            }
        }
    }
}
